import React, { useState } from 'react';
import SupplierTable from './SupplierTable';
import SupplierForm from './SupplierForm';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus } = FiIcons;

export default function SupplierManagement({ suppliers, loading, onAdd, onUpdate, onDelete, isAdmin, canEdit }) {
  const [view, setView] = useState('table');
  const [editingSupplier, setEditingSupplier] = useState(null);

  const handleAddNew = () => {
    setEditingSupplier(null);
    setView('add');
  };

  const handleEdit = (supplier) => {
    setEditingSupplier(supplier);
    setView('edit');
  };

  const handleSave = async (supplierData) => {
    if (view === 'edit' && editingSupplier) {
      await onUpdate(editingSupplier.id, supplierData);
    } else {
      await onAdd(supplierData);
    }
    setView('table');
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            {view === 'table' ? 'Gestión de Proveedores' : (view === 'add' ? 'Agregar Proveedor' : 'Editar Proveedor')}
          </h2>
          <p className="text-gray-500 mt-1">
            Administra tu red de contactos y proveedores para tus productos.
          </p>
        </div>
        
        {canEdit && view === 'table' && (
          <button
            onClick={handleAddNew}
            className="flex items-center px-4 py-2.5 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition-colors shadow-sm"
          >
            <SafeIcon icon={FiPlus} className="mr-2 text-lg" />
            Agregar Proveedor
          </button>
        )}
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-20">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600"></div>
        </div>
      ) : view === 'table' ? (
        <SupplierTable
          suppliers={suppliers}
          onEdit={handleEdit}
          onDelete={onDelete}
          isAdmin={isAdmin}
          canEdit={canEdit}
        />
      ) : (
        <SupplierForm
          initialData={editingSupplier}
          onSave={handleSave}
          onCancel={() => setView('table')}
        />
      )}
    </div>
  );
}